<ui-section>
  <ui-block width="5x">
  <div class="flex flex-col">
    <span class="one-row">
      <!-- <span>GREEN_CHECKMARK</span> -->
      <ui-overlay-icon [icon]="OverlayIcons.GREEN_CHECKMARK" style="display: inline;" />
    </span>
    <pre><code class="language-html">&lt;ez-overlay-icon [icon]="OverlayIcons.GREEN_CHECKMARK" /&gt;</code></pre>

    <span class="one-row">
      <!-- <span>RED_X</span> -->
      <ui-overlay-icon [icon]="OverlayIcons.RED_X" [scale]="2" />
    </span>
    <pre><code class="language-html">&lt;ez-overlay-icon [icon]="OverlayIcons.RED_X" [scale]="2"/&gt;</code></pre>

    <span class="one-row">
      <!-- <span>YELLOW_EXCLAMATION</span> -->
      <ui-overlay-icon [icon]="OverlayIcons.YELLOW_EXCLAMATION" [sizeInPx]="20" [scale]="2"/>
    </span>
    <pre><code class="language-html">&lt;ez-overlay-icon [icon]="OverlayIcons.YELLOW_EXCLAMATION" [sizeInPx]="20" /&gt;</code></pre>

  </div>
  </ui-block>
</ui-section>
